var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dborder dinline-block vtop tcenter br8",style:({backgroundImage:'url('+_vm.item.image+')',backgroundPosition:'0 0',backgroundRepeat:'no-repeat'})},[_c('div',{staticClass:"lh16"},[_vm._v(_vm._s(_vm.item.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e040c26","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/about/school-tag.vue
// module id = null
// module chunks = 